'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionsTypeConsts = require('./actionsTypeConsts.js');

var _actionsTypeConsts2 = _interopRequireDefault(_actionsTypeConsts);

var _alertTypes = require('./alertTypes.js');

var _alertTypes2 = _interopRequireDefault(_alertTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-case-declarations */
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case _actionsTypeConsts2.default.providerSuccessfullyChanged:
    case _actionsTypeConsts2.default.closeAlert:
      state = null;
      break;
    case _actionsTypeConsts2.default.selectProvider:
      state = {
        type: _alertTypes2.default.selectionPrompt,
        provider: payload
      };
      break;
    case _actionsTypeConsts2.default.setAlert:
      var alertType = payload.alertType,
          alertPayload = payload.alertPayload;

      state = {
        type: alertType,
        provider: alertPayload
      };
      break;
    default:
      break;
  }
  return state;
};
/* eslint-enable no-case-declarations */